export function idxFunc() {

  /**
   * スクロールでヘッダーロゴ表示
   */
  $(window).on('scroll', function () {
    let $header = $('.home .header');
    let hideClass = 'header--hide-logo';

    if ($(window).scrollTop() > 500 && $header.hasClass(hideClass)) {
      $header.removeClass(hideClass);
    } else if($(window).scrollTop() < 100 && !$header.hasClass(hideClass)) {
      $header.addClass(hideClass);
    }
  });


  /**
   * タイトルアニメーション
   */
  $(window).scroll(function (){
    $('.moving-title').each(function(){
      var winHeight = $(window).height();
      var winWidth = $(window).width();
      var position = $(this).offset().top;
      var scroll = $(window).scrollTop();
      var distance = 0;
      if (winWidth < 768) {
        // スマホ
        distance = (scroll + winHeight - position) / 10;
      } else {
        // PC
        distance = (scroll + winHeight - position) / 4;
      }

      if (distance > 0 && distance < 500) {
        if ($(this).hasClass('moving-title--left')) {
          $(this).css('left', distance);
        } else if ($(this).hasClass('moving-title--right')) {
          $(this).css('right', distance);
        }
      }
    });
  });

  /**
   * CAREERE アニメーション
   */
  var dateNum = $('.index-career-timeline__date').length;
  var dateCount = 0;
  setInterval(function() {
    $('.index-career-timeline__date').removeClass('index-career-timeline__date--active');
    $('.index-career-timeline__date').eq(dateCount).addClass('index-career-timeline__date--active');

    if (dateCount >= dateNum - 1) {
      dateCount = 0;
    } else {
      dateCount++;
    }
  }, 1000);
}